import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@18.19.110_db0@0.3.2_eslint_t2ykcx5otu5g34mebxjltn3ldu/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/usr/src/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}